import React from "react";
import "./Textarea.css";

interface TextareaProps {
  disabled: boolean;
  name?: string;
  errorMessage?: string | string[];
  iserror?: boolean;
  value?: string;
  label?: string;
  placeholder?: string;
  rows?: number;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
}

export const Textarea = ({
  disabled,
  name,
  errorMessage,
  iserror,
  value,
  label,
  placeholder,
  rows = 4,
  onChange,
  onBlur,
}: TextareaProps) => {
  return (
    <div
      className="textarea-group"
      style={disabled ? { pointerEvents: "none", opacity: 0.4 } : {}}
    >
      <div className="textarea-wrapper-label">
        <label className="textarea-label">
          <p>{label}</p>
        </label>
      </div>

      <div className="textarea-wrapper-field">
        <textarea
          name={name}
          value={value}
          placeholder={placeholder}
          rows={rows}
          className="textarea-box"
          style={{
            border: iserror ? "1.5px solid red" : undefined,
          }}
          onChange={disabled ? undefined : onChange}
          onBlur={onBlur}
        />

        {iserror && <div className="textarea-error">{errorMessage}</div>}
      </div>
    </div>
  );
};